var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C16 13.1053 15.0216 14 13.813 14C12.777 14 11.8945 13.3158 11.6835 12.4211H0.47962C0.21103 12.4211 0 12.2281 0 11.9825C0 11.7369 0.21103 11.5439 0.47962 11.5439H11.6835C11.9137 10.6667 12.777 10 13.813 10C15.0024 10 16 10.8947 16 12V12ZM15.0408 11.9825C15.0408 11.3684 14.4844 10.8597 13.813 10.8597C13.1415 10.8597 12.5851 11.3684 12.5851 11.9825C12.5851 12.5965 13.1415 13.1053 13.813 13.1053C14.4844 13.1053 15.0408 12.5965 15.0408 11.9825V11.9825Z",
    fill: "#001823"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.91228 0.97959 0 2.18968 0C3.22689 0 4.11045 0.66667 4.32173 1.5614H15.5198C15.7887 1.5614 16 1.75438 16 2C16 2.24561 15.7887 2.4386 15.5198 2.4386H4.32173C4.11045 3.33334 3.22689 4 2.18968 4C0.9796 4 0 3.08772 0 2H0ZM0.96038 2C0.96038 2.61404 1.5174 3.12281 2.18967 3.12281C2.86194 3.12281 3.41896 2.61404 3.41896 2C3.41896 1.38596 2.86194 0.87719 2.18967 0.87719C1.5174 0.87719 0.96038 1.38596 0.96038 2V2Z",
    fill: "#001823"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7C16 7.24561 15.7892 7.43859 15.521 7.43859H10.0599C9.84911 8.33333 8.96767 9 7.93294 9C6.89821 9 6.01677 8.33333 5.80599 7.43859H0.47904C0.21078 7.43859 0 7.24561 0 7C0 6.75439 0.21078 6.56141 0.47904 6.56141H5.80599C6.01677 5.66667 6.89821 5 7.93294 5C8.96767 5 9.84911 5.66667 10.0599 6.56141H15.521C15.7701 6.56141 16 6.77193 16 7V7ZM9.15929 7C9.15929 6.38597 8.6036 5.87719 7.93294 5.87719C7.26228 5.87719 6.70659 6.38597 6.70659 7C6.70659 7.61403 7.26228 8.12281 7.93294 8.12281C8.6036 8.12281 9.15929 7.61403 9.15929 7Z",
    fill: "#001823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e85409ae365bb474c1ebb5bf182c6330.svg";
export { ForwardRef as ReactComponent };